var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 1.3C19.8 1.10537 19.7484 0.914223 19.6505 0.746054C19.5525 0.577885 19.4117 0.43872 19.2423 0.342762C19.073 0.246804 18.8813 0.197488 18.6867 0.199849C18.492 0.20221 18.3015 0.256162 18.1346 0.356199L7.3964 6.7956H3.3C1.4762 6.7956 0 8.2696 0 10.0956V18.9C0 20.7238 1.474 22.2 3.3 22.2H7.3964L18.1324 28.6438C18.2994 28.7444 18.4901 28.7988 18.6851 28.8014C18.88 28.8041 19.0721 28.7549 19.2418 28.6589C19.4115 28.5628 19.5526 28.4234 19.6506 28.255C19.7487 28.0865 19.8003 27.895 19.8 27.7V1.3ZM29.0576 14.4912L32.164 17.602L30.6086 19.1574L27.5 16.0466L24.3892 19.1552L22.8338 17.5998L25.9446 14.4912L22.8338 11.3826L24.3892 9.8272L27.5 12.9358L30.613 9.8272L32.1662 11.3826L29.0576 14.4912Z",
    fill: "url(#paint0_linear_300_18)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_18",
    x1: 16.0831,
    y1: 0.199768,
    x2: 16.0831,
    y2: 28.8015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.f419b78fc31a2e094848eeb37c7067e3.svg";
export { ForwardRef as ReactComponent };